import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

export enum PageIndex {
  HOME,
  SCHEDULE,
  WORKLOG,
  VACATION,
  YEARLY_SUMMARY,
  ADMINS_PAGE,
  USERS,
  PROJECTS,
  PROJECTS_DISTRIBUTION,
  REPORTS,
  CANDIDATES,
  DEMANDS,
  COST_SUMMARY,
  PROFILE,
  SETTINGS,
  LOGOUT,
  SETTLEMENTS,
  LEADER_VIEW,
}

interface PageNameState {
  index: PageIndex
  value: string
}

const initialState: PageNameState = {
  index: PageIndex.HOME,
  value: '',
}

export const pageNameSlice = createSlice({
  name: 'pageName',
  initialState,
  reducers: {
    setPageName: (state, action: PayloadAction<string>) => {
      state.value = action.payload
    },
    setPageIndex: (state, action: PayloadAction<PageIndex>) => {
      state.index = action.payload
    },
  },
})

export const { setPageName, setPageIndex } = pageNameSlice.actions

export const selectPageName = (state: RootState) => state.pageName.value
export const selectPageIndex = (state: RootState) => state.pageName.index

export default pageNameSlice.reducer
